// extracted by mini-css-extract-plugin
export default {"wrapper":"ww-z","button":"xw-z","alternate":"yw-z","disabled":"zw-z","paymentWarning":"Aw-z","fadeIn":"Bw-z"};